import { ActivityListField, type BodyRowConfig } from '@ztechapps/webui.data-tools'
import type { Order } from '@ztechapps/common.contract'
import { LocalDate, LocalDateTime } from '@ztechapps/webui.date'
import { Link } from 'react-router-dom'
import { formatMoney } from '@ztechapps/common.utils'
import { Tags } from '@ztechapps/webui.input'
import { Icon, ShowIf } from '@ztechapps/webui.util'
import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { useOrderListContext } from './Context'
import { OrderPaymentStatusBadge } from '../OrderPaymentStatusBadge'
import { OrderStatusBadge } from '../StatusBadge'

export const TrackingNumberColumn = (props: BodyRowConfig<Order>) => {
  const { shipping } = props
  const dataArray = shipping?.packages ?? []

  return (
    <div className="d-flex justify-content-start flex-wrap gap-1">
      {dataArray.map((m) => (
        <a key={m?.tracking_number} href={m.trackingUrl} target="_blank" rel="noreferrer">
          {m.tracking_number}
        </a>
      ))}
    </div>
  )
}

export const CodeColumn = (props: BodyRowConfig<Order>) => {
  const { orderItemRoute } = useOrderListContext()

  const { code, _id } = props
  return (
    <Link to={orderItemRoute.altPath({ _id })}>
      <b>{code}</b>
    </Link>
  )
}

export const StatusColumn = (props: BodyRowConfig<Order>) => {
  const { status } = props
  return <OrderStatusBadge status={status} />
}

export const CompanyColumn = (props: BodyRowConfig<Order>) => {
  const { companyItemRoute } = useOrderListContext()

  const { by } = props
  return <Link to={companyItemRoute.altPath({ _id: by?.company?._id })}>{by.company?.name ?? ''}</Link>
}

export const DataListRow = (props: BodyRowConfig<Order>) => {
  const { createdAt, net, by, shipping, paymentStatus, payments, qboId, tags, updatedAt, remarks, remarksActivity } =
    props
  const { customerItemRoute } = useOrderListContext()

  return props._renderDataBodyCell({
    shippingDate: <LocalDate value={shipping?.date} />,
    companyName: <CompanyColumn {...props} />,
    contactName: <Link to={customerItemRoute.altPath({ _id: by?._id })}>{by.profile?.name ?? ''}</Link>,
    netAmount: <div className="fw-bold text-end">{formatMoney(net)}</div>,
    paymentStatus: paymentStatus && <OrderPaymentStatusBadge paymentStatus={paymentStatus} payments={payments} />,

    tags: <Tags dataArray={tags} />,
    createdAt: <LocalDateTime value={createdAt} />,
    status: <StatusColumn {...props} />,
    code: <CodeColumn {...props} />,
    updatedAt: <LocalDateTime value={updatedAt} />,
    qboId: (
      <ShowIf condition={!isEmpty(qboId)}>
        <div className="text-break">
          <Icon className={'text-primary'} name={'check'} />
        </div>
      </ShowIf>
    ),
    remarks: <ActivityListField remarks={remarks} remarksActivity={remarksActivity} />,
    trackingNumber: <TrackingNumberColumn {...props} />,
  })
}
